import React, { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import ReactPlayer from 'react-player';
import Iframe from 'react-iframe'; // Import Iframe from your specific path

const CustomPlayer = forwardRef((props, ref) => {
  const playerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [URL, setURL] = useState(props.videoURL);
  const [canPlay, setCanPlay] = useState(true);
  const [showButton, setShowButton] = useState(true);
  const [isPhone, setIsIphone] = useState(/iPhone/.test(navigator.userAgent))

  useEffect(() => {
    setURL(props.videoURL);
    setIsIphone(/iPhone/.test(navigator.userAgent));
  }, [props.videoURL]);

  const handleError = (error) => {
    console.error('Error playing video:', error);
    setCanPlay(false);
  };

  const handlePlayPause = () => {
    setPlaying(!playing);
    setShowButton(true);
  };

  const handleMouseAndTouchMove = () => {
    setShowButton(true);
  };

  const handleMouseAndTouchEnter = () => {
    setShowButton(true);
  };

  const handleMouseAndTouchLeave = () => {
    setShowButton(false);
  };

  const handlePlay = () => {
    window.speechSynthesis.cancel();
   // alert(window.speechSynthesis.cancel())
    props.videoOverlayDisplayPlay();
  };
  const handlePause = () => {
    props.videoOverlayDisplayPause();
  };

  return (
    <>
      {canPlay ? (
        <div className='container-video-overlay' id='reactVideoPlayer'>
          <ReactPlayer
            ref={playerRef}
            url={URL}
            controls={true}
            playing={false}
            className={`${isPhone === true? 'react-player-mobile-video-iphone' : "react-player-mobile-video"}`}
            onError={handleError}
            playsInline={false}
            onPlay={handlePlay}
            onPause={handlePause}
            id="playerRef"
            allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
            config={{
              file: { attributes: { playsInline: true, }, },
              vimeo: {
                playerOptions: {
                  playsinline: false,
                  autopause: true,
                  vimeo_logo: false,
                },
              },

              youtube: {
                playerVars: { showinfo: 1 },
                playsInline: false,
              },
              playsInline: false
            }}
          />
        </div>
      ) : (
        <div
          className='container-video-overlay'
        >
          <Iframe
            url={URL}
            className={`${isPhone === true? 'react-player-mobile-video-iphone' : "react-player-mobile-video"}`}
            allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"
          />
        </div>

       )} 
    </>
  );
});

export default CustomPlayer;
